var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_86_1704)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 44,
    height: 44,
    rx: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.666 29.9998C21.666 29.5396 22.0391 29.1665 22.4993 29.1665H37.4993C37.9596 29.1665 38.3327 29.5396 38.3327 29.9998C38.3327 30.4601 37.9596 30.8332 37.4993 30.8332H22.4993C22.0391 30.8332 21.666 30.4601 21.666 29.9998Z",
    fill: "#FAE8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.666 24.9998C21.666 24.5396 22.0391 24.1665 22.4993 24.1665H37.4993C37.9596 24.1665 38.3327 24.5396 38.3327 24.9998C38.3327 25.4601 37.9596 25.8332 37.4993 25.8332H22.4993C22.0391 25.8332 21.666 25.4601 21.666 24.9998Z",
    fill: "#FAE8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 34.1665C22.0391 34.1665 21.666 34.5396 21.666 34.9998C21.666 35.4601 22.0391 35.8332 22.4993 35.8332H37.4993C37.9596 35.8332 38.3327 35.4601 38.3327 34.9998C38.3327 34.5396 37.9596 34.1665 37.4993 34.1665H22.4993Z",
    fill: "#FAE8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_86_1704",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.698039 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_1704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_1704",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.419608 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_86_1704"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamDefault);
export default __webpack_public_path__ + "static/media/hamDefault.9666849f037f50cd9f4a5fc1debcfbc3.svg";
export { ForwardRef as ReactComponent };